import { type OptionType } from '@atlaskit/select';

import { type PopupSelectOption } from './index';

export const instanceOfPopupSelectOption = (
	option: OptionType | readonly OptionType[],
): option is PopupSelectOption | PopupSelectOption[] => {
	const arrayOfOptions = Array.isArray(option) ? option : [option];

	return arrayOfOptions.every(
		(popupOption) =>
			popupOption?.isSelected !== undefined &&
			popupOption?.value !== undefined &&
			popupOption?.trackingKey !== undefined &&
			popupOption?.value !== undefined &&
			popupOption?.queryParamValue !== undefined &&
			popupOption?.isSuggested !== undefined &&
			popupOption?.isDefault !== undefined &&
			popupOption?.label !== undefined,
	);
};
